<template>
  <div>
    <!-- <img src="../assets/images/bg.png" alt="bg1" class="background-image2" /> -->
    <transition
      appear
      @before-enter="$animations.beforeEnterLogoArea"
      @enter="$animations.enterLogoArea"
    >
      <Logo></Logo>
    </transition>

    <!-- <transition
      appear
      @before-enter="$animations.beforeEnterAbove"
      @enter="$animations.enterAbove"
    >
      <div class="columns mb-5 is-centered">
        <div
          v-if="$root.selectedLanguage === `en`"
          class="column"
          style="text-align: center"
        >
          <img
            src="../assets/images/icons/updatedIcons/normalFlow/verificationInfo.png"
            alt="socialmedia.png"
            width="70%"
          />
        </div>
        <div
          v-if="$root.selectedLanguage === `si`"
          class="column"
          style="text-align: center"
        >
          <img
            src="../assets/images/icons/RBDSecondheaderImagesSin/Group 37577.png"
            alt="socialmedia.png"
            width="70%"
          />
        </div>
      </div>
    </transition> -->
    <transition appear @before-enter="$animations.beforeEnterAbove" @enter="$animations.enterAbove">
      <div class="columns mb-0 is-centered">
        <div v-if="$root.selectedLanguage === `en` && $root.formData.childrenAccountOpeningPurpose == `For another person's child (Gift Account)`" class="column" style="text-align: center">
          <img src="../assets/images/icons/updatedIcons/donorFlow/verificationInfo.png" alt="contact-img" width="85%" />
        </div>
        <div v-if="$root.selectedLanguage === `en` && $root.formData.childrenAccountOpeningPurpose != `For another person's child (Gift Account)`" class="column" style="text-align: center">
          <img src="../assets/images/icons/updatedIcons/normalFlow/verificationInfo.png" alt="contact-img" width="85%" />
        </div>
        <div v-if="$root.selectedLanguage === `si`" class="column" style="text-align: center">
          <img src="../assets/images/icons/RBDSecondheaderImagesSin/Group 37572.png" alt="contact-img" width="70%" />
        </div>
      </div>
    </transition>
<div class="card px-3" >
    <transition
      appear
      @before-enter="$animations.beforeEnterAbove"
      @enter="$animations.enterAbove"
    >
      <div class="columns is-centered">

        <div class="column is-8" style="text-align: center">
          <img
            src="../assets/images/icons/Blue/Shield Done.png"
            alt="contact-info-img"
            width="70"
            height="70"
          />
          <p
            :class="`text-center mx-3 verificationText ${
              $root.selectedLanguage === `ta`
                ? `ta-he-line`
                : $root.selectedLanguage === `si`
                ? `si-he-line`
                : `en-he-line`
            }`"
            style="font-family: OpenSans-Bold; "
          >
            {{ $root.selectedLanguageData.verification }}
          </p>
          <p
            :class="`text-center mx-3 ${
              $root.selectedLanguage === `ta`
                ? `ta-sub-line`
                : $root.selectedLanguage === `si`
                ? `si-sub-line`
                : `en-sub-line`
            }`"
            style="font-family: OpenSans-Bold; "
          >
            {{ $root.selectedLanguageData.wehavesentanOTPtoyourmobile }}
          </p>
          <p>
            {{
              $root.formData.mobileNumber
                  ? $root.formData.mobileNumber
                  : ($root.formData.guardian_email ? $root.formData.guardian_email : "Loading...")

            }}
          </p>
        </div>
      </div>
    </transition>
    <ValidationObserver v-slot="{ invalid }">
      <form @submit.prevent="">
        <div class="columns is-centered">
          <div class="column is-three-quarters">
            <transition
              appear
              @before-enter="$animations.beforeEnterBelow"
              @enter="$animations.enterBelow"
            >
<!--              <div class="columns">-->
<!--                <div-->
<!--                  class="column is-half"-->
<!--                  v-if="$root.kycFieldVisibility.introduced_by"-->
<!--                >-->
<!--                  <label-->
<!--                    :class="`${-->
<!--                      $root.selectedLanguage === `ta`-->
<!--                        ? `ta-label`-->
<!--                        : $root.selectedLanguage === `si`-->
<!--                        ? `si-label`-->
<!--                        : ``-->
<!--                    }`"-->
<!--                    >{{ $root.selectedLanguageData.introduced_by }}</label-->
<!--                  >-->
<!--                  <b-field>-->
<!--                    <b-input-->
<!--                    -->
<!--                      type="text"-->
<!--                      @focus="$inputFocused('introduced_by')"-->
<!--                      @input="$inputChanged('introduced_by')"-->
<!--                      @blur="$inputBlured('introduced_by')"-->
<!--                      v-model="$root.formData.introduced_by"-->
<!--                    />-->
<!--                  </b-field>-->
<!--                </div>-->
<!--              </div>-->
            </transition>

            <transition
              appear
              @before-enter="$animations.beforeEnterBelow"
              @enter="$animations.enterBelow"
            >
              <div>
                <div>
                  <label
                    :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                    >{{ $root.selectedLanguageData.otpToPhone
                    }}<span class="has-text-danger"> *</span></label
                  >
                </div>
                <b-field>
                  <ValidationProvider
                    name="OTP"
                    :rules="{ length: 6, required: true }"
                    v-slot="{ errors }"
                  >
                    <p class="control has-icons-right">
                      <b-input
                   
                        type="text"
                        v-model="$root.formData.Otp"
                      />
                      <span class="icon is-small is-right mr-2">
                        <img
                          src="../assets/images/icons/Blue/otp.png"
                          alt="otp-img"
                          width="25"
                          height="25"
                        />
                      </span>
                    </p>
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
            </transition>

            <transition
              appear
              @before-enter="$animations.beforeEnterBelow"
              @enter="$animations.enterBelow"
            >
<div class="columns">
                <div class="column">
                  <p style="text-align: start">
                    {{ $root.selectedLanguageData.didnotReceive }}
                  </p>
                </div>
                <div class="column">
                  <p style="text-align: end;font-family: OpenSans-Bold">
                    {{ $root.selectedLanguageData.resendOTPin }}
                    <span style="color: #009ec2; font-weight: 500"
                      >{{ countDown }} s</span
                    >
                  </p>
                </div>
</div>

            </transition>

            <div>
              <transition
                appear
                @before-enter="$animations.beforeEnterBelow"
                @enter="$animations.enterBelow"
              >
                <div v-if="$root.kycFieldVisibility.contact_no">
                  <p
                    @click="
                      () => {
                        isModalActive = true;
                        const tempCountryCodeName =
                          $root.formData.countriesList.find(
                            (country) =>
                              country.phone === $root.formData.countryCode
                          );
                        userCode = countryCodeArray.find(
                          (hello) =>
                            hello ===
                            `${tempCountryCodeName.code} ${$root.formData.countryCode}`
                        );

                        newCountryCode = $root.formData.countryCode;
                        yourMobileNumber = $root.formData.mobileNumber;
                        changeSelection();
                      }
                    "
                    yourMobileNumber="$root.formData.email"
                  >
                    <!--                Change your -->
                    {{ $root.selectedLanguageData.changeMobilePhase1 }}
                    <span
                      :style="{
                        color: '#009ec2',
                        'font-family': 'OpenSans-Bold',
                        'letter-spacing': '0.5px',
                        'text-decoration': 'underline',
                        cursor: 'pointer',
                      }"
                    >
                      <!--                  mobile number -->
                      {{ $root.selectedLanguageData.changeMobilePhase2 }}
                    </span>
                  </p>
                </div>
              </transition>

              <b-modal v-model="isModalActive" :width="500" scroll="keep">
                <div class="card">
                  <header class="modal-card-head">
                    <div class="is-size-4" style="text-align: center; font-family: OpenSans-Bold">
                      {{ $root.selectedLanguageData.changeMobileNumber }}
                    </div>
                    <div class="modal-close-button">
                      <button
                        class="delete"
                        aria-label="close"
                        @click="isModalActive = false"
                      ></button>
                    </div>
                  </header>
                  <div class="card-content mx-4">
                    <div>
                      {{ $root.selectedLanguageData.mobileNumChangeConditon }}
                    </div>
                    <div class="mt-2">
                      <label
                        :class="`${
                          $root.selectedLanguage === `ta`
                            ? `ta-label`
                            : $root.selectedLanguage === `si`
                            ? `si-label`
                            : ``
                        }`"
                        >{{ $root.selectedLanguageData.newMobileNumLable
                        }}<span class="has-text-danger">*</span></label
                      >
                      <div class="columns is-7 is-variable">
                        <div class="column is-two-fifths">
                          <div>
                            <b-field>
                              <p class="control has-icons-right">
                                <b-autocomplete
                                  v-model="userCode"
                                  icon-pack="fi"
                                  :icon="iconString"
                                  open-on-focus
                                  :data="filteredDataArr"
                                 
                                  @input="
                                    () => {
                                      ++count;
                                      if (count === 1) {
                                        newCountryCode = ``;
                                        isCountryCodeTouched = true;
                                      }
                                    }
                                  "
                                  @select="
                                    (option) => {
                                      option
                                        ? (newCountryCode = `+${
                                            option.split(`+`)[1]
                                          }`)
                                        : (newCountryCode = ``);
                                      if (newCountryCode) {
                                        changeSelection();
                                      }
                                      validateMobileNumber();
                                    }
                                  "
                                >
                                </b-autocomplete>
                                <span class="icon is-small is-right mr-2">
                                  <img
                                    src="../assets/images/icons/Blue/Stroke.png"
                                    alt="Stroke-img"
                                    width="13"
                                    height="13"
                                  />
                                </span>

                                <span
                                  class="has-text-danger"
                                  v-if="isCountryCodeTouched && !newCountryCode"
                                  >You have to select a valid country code</span
                                >
                              </p>
                            </b-field>
                          </div>
                        </div>
                        <div class="column">
                          <b-field>
                            <p class="control has-icons-right">
                              <ValidationProvider
                                name="Phone Number"
                                :rules="{ required: true, onlyNumbers: true }"
                                v-slot="{ errors, valid }"
                                ><p class="calMobileError">
                                  {{
                                    valid
                                      ? ($root.isMobileError = valid)
                                      : ($root.isMobileError = valid)
                                  }}
                                </p>
                                <b-input
                                
                                  type="tel"
                                  v-model="yourMobileNumber"
                                  @focus="$inputFocused('contact_no')"
                                  @blur="$inputBlured('contact_no')"
                                  @input="
                                    () => {
                                      $inputChanged('contact_no');
                                      validateMobileNumber();
                                    }
                                  "
                                />
                                <span class="icon is-small is-right mr-2">
                                  <img
                                    src="../assets/images/icons/Blue/Call.png"
                                    alt="contact-name-img"
                                    width="25"
                                    height="25"
                                  />
                                </span>
                                <span class="has-text-danger">{{
                                  errors[0]
                                }}</span>
                                <span
                                  class="has-text-danger"
                                  v-if="isMobileNumberStartsWithZero"
                                  >LK phone numbers not allowed to start with
                                  0</span
                                >
                              </ValidationProvider>
                            </p>
                          </b-field>
                        </div>
                      </div>
                    </div>
                    <b-button
                      class="mt-6"
                      type="is-primary"
                      @click="
                        () => {
                          isModalActive = false;
                          $root.formData.mobileNumber = yourMobileNumber;
                          $root.formData.countryCode = newCountryCode;
                          calPhoneNumber();
                        }
                      "
                      :disabled="
                        !$root.isMobileError ||
                        !newCountryCode ||
                        isMobileNumberStartsWithZero
                      "
               
                      expanded
                      >{{
                        $root.selectedLanguageData.changeMobileNumberButton
                      }}</b-button
                    >
                  </div>
                </div>
              </b-modal>
            </div>
            <div class="mt-3">
              <transition
                appear
                @before-enter="$animations.beforeEnterBelow"
                @enter="$animations.enterBelow"
              >
                <div>
                  <ValidationProvider
                    :rules="{ required: true }"
                    v-slot="{ errors }"
                  >
                    <b-checkbox
                      type="is-primary"
                      style="font-size: 1.1rem; font-family: OpenSans-Regular"
                      @focus="
                        $inputFocused('agree_with_the_verification_attached')
                      "
                      @input="
                        $inputChanged('agree_with_the_verification_attached')
                      "
                      @blur="
                        $inputBlured('agree_with_the_verification_attached')
                      "
                      v-model="
                        $root.formData.agree_with_the_verification_attached
                      "
                      @change.native="
                        $root.formData.agree_with_the_verification_attached
                          ? (isModalThreeActive = true)
                          : ``
                      "
                    >
                      {{ $root.selectedLanguageData.verification_agreement }}
                    </b-checkbox>
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </transition>
              <b-modal v-model="isModalThreeActive" :width="650" scroll="keep">
                <div class="card">
                  <header class="modal-card-head">
                    <p
                      class="modal-card-title is-flex is-justify-content-center"
                      style="font-family:OpenSans-Bold"
                    >
                      {{ $root.selectedLanguageData.terms_conditions }}
                    </p>
                    <div class="modal-close-button">
                      <button
                        class="delete"
                        aria-label="close"
                        @click="modalReject()"
                      ></button>
                    </div>
                  </header>
                  <div class="card-content">
                    <p class="card-content-text">
                      {{
                        $root.selectedLanguageData.terms_and_conditions_details
                      }}
                    </p>
                    <br />
                    <div class="is-flex is-justify-content-flex-end">
                      <b-button
                        class="reject-button"
                    
                        @click="modalReject()"
                        >{{ $root.selectedLanguageData.reject }}</b-button
                      >
                      <b-button
                        class="is-primary mr-4 agree-button"
                        @click="isModalThreeActive = false"
                     
                        >{{ $root.selectedLanguageData.agree }}</b-button
                      >
                    </div>
                  </div>
                </div></b-modal
              >
            </div>
            <div style="padding-top: 20px;">
            <transition
                appear
                @before-enter="$animations.beforeEnterAbove"
                @enter="$animations.enterAbove"
            >
              <div>
                <!--            <div class="column is-centered is-10 is-offset-4">-->
                <div
                    style="display:flex; justify-content: center; margin-bottom:10px"
                >



                    <b-button
                        class="resend-button "
                        @click="emailButtonAction"
                        :disabled="forThreeMinutes"
                        style="padding=10px; margin-left:20px;"
                    >{{ $root.selectedLanguageData.resend }}</b-button
                    >


                    <b-button
                        :disabled="previousRoute.fullPath !== '/preview-page' && previousRoute.fullPath !== '/guardians_information'"
                        :class="` ${
                    $root.selectedLanguage === `ta`
                      ? `back-button-ta`
                      : $root.selectedLanguage === `si`
                      ? `back-button-si`
                      : `back-button-en`
                  }`"
                        @click="$router.go(-1)"
                    >{{ $root.selectedLanguageData.back }}</b-button
                    >


                    <b-button
                        :class="`is-primary  ${
                    $root.selectedLanguage === `ta`
                      ? `continue-button-ta`
                      : $root.selectedLanguage === `si`
                      ? `continue-button-si`
                      : `continue-button-en`
                  }`"
                        :disabled="
                    invalid ||
                    !$root.formData.agree_with_the_verification_attached
                  "
                        :loading="isContinueButtonLoading"
                        @click="goToCongratulationsPage"
                        style="width:100px;"
                    >{{ $root.selectedLanguageData.continue }}</b-button
                    >

                </div>
                <!--            </div>-->
              </div>
            </transition>
            </div>
          </div>
        </div>

      </form>
    </ValidationObserver>
  </div>
    <GetHelp v-if="false"></GetHelp>
  </div>
</template>
<script>
import GetHelp from "./GetHelp.vue";
import Logo from "./NsbKycLogo.vue";
import {submitPageInputs} from "@/util/util";
export default {
  components: {
    GetHelp,
    Logo,
  },
  data() {
    return {
      count: 0,
      newCountryCode: "",
      yourMobileNumber: "",
      isModalThreeActive: false,
      isModalActive: false,
      forThreeMinutes: false,
      country: "",
      countDown: "",
      iconString: "",
      isContinueButtonLoading: false,
      userCode: "",
      countryCodeArray: [],
      isMobileNumberStartsWithZero: false,
      isCountryCodeTouched: false,
      submitPageInputs : submitPageInputs,
      previousRoute: "",
      isContinueFromDonor : 0,

    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousRoute = from;
      console.log(vm.previousRoute," previousRoute")
    });
  },
  methods: {

    /**
     * =================================================================================================================
     * This method can be used to get date in requested format  : month/date/year
     * @param date
     * @returns {string}
     */
    formatDate(date){
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate()

      if(month < 10){
        month = "0"+month;
      }
      let output = [month,day,year]
      return output.join("/")
    },


    /**
     * ===========================================================================
     * This method can be used to get values separated from commas using a list containing objects of the following type
     * @param list  {"value":"","langTranslation":""} with objects
     * @returns {string} values seperated by commas
     */
    getValuesSeperatedWithCommas(list) {
      var formattedItemsArray = [];

      list.forEach((item) => {
        formattedItemsArray.push(item.value);
      });

      return formattedItemsArray.toString();
    },

    changeSelection() {
      const countryCodeTemp = this.$root.formData.countriesList.find(
        (countryObject) => countryObject.phone === this.newCountryCode
      );
      this.$root.formData.country_short_name = `${countryCodeTemp.code} ${countryCodeTemp.phone}`;
      this.iconString = `fi fi-${countryCodeTemp.code.toLowerCase()}`;
    },

    modalReject() {
      this.$root.formData.agree_with_the_verification_attached = false;
      this.isModalThreeActive = false;
    },
    calPhoneNumber() {
      this.$root.formData.contact_no = `${this.$root.formData.countryCode}${this.$root.formData.mobileNumber}`;
    },

    sendFinalOTP() {
      try {
        window.element = this;
        let otherNamesSplited = this.$root.formData.other_name
          .trim()
          .split(" ");
        let firstName = otherNamesSplited[0];
       // console.log("First name to send final otp : " + firstName);

         let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12
        this.$http
          .post(this.$baseURL + "/kycForm/sendFinalOTP", {
            email: this.$root.formData.email,
            name: firstName,
            contactNo: this.$root.formData.mobileNumber,
          },{
            headers:{'X-token':kyc_token}
          })
          .then((response) => {
            if (response.data.success) {
              this.$root.formData.finalOTP = response.data.data.otp;
            } else {
              //console.log(response.data);
              this.$buefy.toast.open({
                message: "Failed to send OTP",
                type: "is-danger",
              });
            }
          }).catch((response) => {
            this.$buefy.toast.open({
                message: response.message,
                type: "is-danger",
            });
        });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to send OTP",
          type: "is-danger",
        });
      }
    },
    updateLastStep() {

      try {
        window.element = this;
        let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12
        this.$http
            .post(this.$baseURL + "/kycForm/updateLastStep", {
              last_step_name:'Preview',
              last_step: 8,
              form_filled:true,
              next_route:'Employment Info',
            },{
              headers:{'X-token':kyc_token}
            })
            .then((response) => {
              console.log(response.data);

              if (response.data.success) {
                console.log(response.data);
              } else {
                console.log(response.data);
              }
            }).catch((response) => {
          this.$buefy.toast.open({
            message: response.message,
            type: "is-danger",
          });
        });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to update last step",
          type: "is-danger",
        });
      }
    },

    goToCongratulationsPage() {
      const otpValidationEndpoint = this.isContinueFromDonor == 1 ? "/validateDonerOTP" : "/kycForm/validateFinalOTP"

      // const dataPaylload =( this.isContinueFromDonor == 1) ? {otp_code:this.$root.formData.Otp, id: formID} : ''


            // if (this.$root.formData.Otp == this.$root.formData.finalOTP) {
      //   // this.test();
      //   this.invalid = false;
      //   this.isContinueButtonLoading = true;
      //   this.submitForm();
      //
      //   console.log(
      //     "Calculated KeyStroke values ====================================="
      //   );
      //   console.log(this.$root.keyStrokeDynamics);
      // } else {
      //   this.$buefy.toast.open({
      //     message: "Entered OTP does not match with OTP sent",
      //     type: "is-danger",
      //   });
      //
      //   this.invalid = true;
      // }
      const queryString = window.location.search;
      let formID = queryString.replace(/^\D+/g, '')

      try {
        window.element = this;
        let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12
        console.log("kyc token -----",kyc_token)
        this.$http
            .post(this.$baseURL + otpValidationEndpoint, {
              otp_code:this.$root.formData.Otp,
              id: formID
            },{
              headers:{'X-token':kyc_token}
            })
            .then((response) => {
              //console.log(response.data);
              if(response.data.success == true){
                this.invalid = false;
                this.isContinueButtonLoading = true;
                console.log(response.data)
                if (this.previousRoute.fullPath === '/preview-page') {
                  this.submitForm();
                }
                else if(this.previousRoute.fullPath === '/guardians_information'){
                  console.log("otp matched..............")
                  this.submitPageInputs(true, 'congratulation', 'preview-page', 'congratulation', 1, 1, true);
                }
                else if(this.isContinueFromDonor == 1){
                  this.$root.formData = JSON.parse(response.data.data.filledData)
                  this.$router.push('/')
                }
                // else if(this.isContinueFromDonor){
                //
                // }
              } else {
                this.$buefy.toast.open({
                  message: "Entered OTP does not match with OTP sent",
                  type: "is-danger",
                });
                this.invalid = true;
              }
            }).catch((response) => {
            this.$buefy.toast.open({
                message: response.message,
                type: "is-danger",
            });
        });
        // this.submitForm();
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to send OTP email",
          type: "is-danger",
        });
      }
    },

    emailButtonAction: function () {
      this.sendFinalOTP();

      this.forThreeMinutes = true;
      this.countDown = 60;
      this.timerCount();
      setTimeout(() => {
        this.forThreeMinutes = false;
      }, 60000);
    },

    timerCount: function () {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.timerCount();
        }, 1000);
      }
    },

    //this function for checking keystroke values
    // test() {
    //   console.log(this.$root.keyStrokeDynamics);
    // },

    submitForm: function () {
      var comp = this;
     

      var bodyFormData = new FormData();

      bodyFormData.append("kyc_branch", comp.$root.formData.branch);


      let identificationType = "old-nic";
      if (comp.$root.formData.idType === "ONIC") {
        identificationType = "old-nic";
      } else if (comp.$root.formData.idType === "NNIC") {
        identificationType = "new-nic";
      } else if (comp.$root.formData.idType === "PNO") {
        identificationType = "passport";
      }

      // let publicPositionsHeldBySelf = "No";
      // if (
      //   comp.$root.formData.politically_exposed ==
      //   "public Positions Held BySelf"
      // ) {
      //   publicPositionsHeldBySelf = "Yes";
      // } else {
      //   publicPositionsHeldBySelf = "No";
      // }

      bodyFormData.append("account_type", comp.$root.formData.account_type);
      bodyFormData.append("currency_type", comp.$root.formData.currency_type); // new field to add currency type
      bodyFormData.append(
        "currency_type_code",
        comp.$root.formData.currency_type_code
      ); // new field to add currency type code

      bodyFormData.append("contact_no", comp.$root.formData.mobileNumber);
      bodyFormData.append(
        "contact_no_work",
        comp.$root.formData.officeNumber
      );
      bodyFormData.append(
        "contact_no_resident",
        comp.$root.formData.residentNumber
      );
      bodyFormData.append("email", comp.$root.formData.email);
      bodyFormData.append("title", comp.$root.formData.title);

      bodyFormData.append("name_with_init", comp.$root.formData.name_with_init);
      bodyFormData.append("full_name", comp.$root.formData.full_name);
      bodyFormData.append("nic_type", identificationType);
      bodyFormData.append("customer_nic", comp.$root.formData.customer_nic); // done - adjust the above if else

     
      bodyFormData.append("gender", comp.$root.formData.gender);

     
    if (comp.$root.formData.haveNic === 'No' || comp.$root.formData.account === `Minor Savings`){
      bodyFormData.append("date_of_birth",comp.$root.formData.date_of_birth);
    }
    else {
      bodyFormData.append("date_of_birth", comp.$root.formData.customer_dob);
    }

      bodyFormData.append("school",comp.$root.formData.school);
      bodyFormData.append("grade",comp.$root.formData.grade);

      bodyFormData.append("marital_status", comp.$root.formData.marital_status);
      bodyFormData.append("spouse_name", comp.$root.formData.spouse_name); // todo :: consider - no field is added yet


      bodyFormData.append("citizenship", comp.$root.formData.citizenship);
      bodyFormData.append("residentship", comp.$root.formData.residentship);
      bodyFormData.append("politically_exposed", comp.$root.formData.politically_exposed);
      //console.log("politically_exposed-----> "+comp.$root.formData.politically_exposed)
      bodyFormData.append("politically_exposed_position", comp.$root.formData.politically_exposed_position);
      //console.log("politically_exposed_position-----> "+comp.$root.formData.politically_exposed_position)

      bodyFormData.append(
        "politically_exposed_relative",
        comp.$root.formData.politically_exposed_relative
      );
      bodyFormData.append(
        "politically_exposed_relative_position",
        comp.$root.formData.politically_exposed_relative_position
      );

    

      // bodyFormData.append("nature_of_business",comp.$root.formData.natureOfEmployment);
      bodyFormData.append('occupation',comp.$root.formData.occupation);
      bodyFormData.append(
        "employment_position",
        comp.$root.formData.employment_position
      );
      bodyFormData.append(
        "employment_position_specify",
        comp.$root.formData.employment_position_specify
      );
      
      bodyFormData.append(
        "employment_position_spouse",
        comp.$root.formData.employment_position_spouse
      ); // todo :: no field is added yet
      bodyFormData.append("employer_name", comp.$root.formData.employer_name);
      bodyFormData.append(
        "employer_name_spouse",
        comp.$root.formData.employer_name_spouse
      ); // todo :: no field is added yet
      bodyFormData.append("employer_addr", comp.$root.formData.employer_addr);
      bodyFormData.append(
        "purpose_of_opening",
        comp.$root.formData.purpose_of_opening.value
        // comp.getValuesSeperatedWithCommas(

        // )
      );
      bodyFormData.append(
        "source_of_income",
        comp.$root.formData.source_of_income
      );
      //console.log("source_of_income-----> "+comp.$root.formData.source_of_income)

      bodyFormData.append(
        "source_of_income_specify",
        comp.$root.formData.other_source_of_income
      );
      //console.log("source_of_income_specify-----> "+comp.$root.formData.other_source_of_income)
      
      bodyFormData.append(
        "income_details",
        comp.$root.formData.income_details
      );
      bodyFormData.append(
        "anticipated_vol",
        comp.$root.formData.anticipated_vol.value
      );
      bodyFormData.append(
        "expected_delivery_channel",
        comp.$root.formData.expected_delivery_channel.value
      );
      bodyFormData.append(
        "other_businesses",
        comp.$root.formData.other_businesses
      );


      // newly added fields start ----------------------------------------------------------------------------

      //account select page
      bodyFormData.append("preferred_branch", comp.$root.formData.branch);
      // bodyFormData.append("account_type", comp.$root.formData.account_type);
      bodyFormData.append("account", comp.$root.formData.account);
      bodyFormData.append("time_period", comp.$root.formData.account_time_period);
      bodyFormData.append("selected_account", comp.$root.formData.account_name);
      bodyFormData.append("isAgreeToNominees", comp.$root.formData.isAgreeToNominees);
      bodyFormData.append("interest_payable_method", comp.$root.formData.interestPayable);
      bodyFormData.append("interest_payment_at", comp.$root.formData.interestPayment);
      bodyFormData.append("transfer_account", comp.$root.formData.transferAccount);
      bodyFormData.append("bank", comp.$root.formData.otherBank);
      bodyFormData.append("branch", JSON.stringify(comp.$root.formData.otherBankBranch));
      bodyFormData.append("account_no", comp.$root.formData.otherBankAccountNumber);
      bodyFormData.append("nominee_data", JSON.stringify(comp.$root.formData.nomineesData));


      //personal information page
      bodyFormData.append("residentship_country", comp.$root.formData.resident_country);
      bodyFormData.append("driving_licence", comp.$root.formData.account_holder_driving_licence);
      bodyFormData.append("customer_passport_no", comp.$root.formData.account_holder_passport_number);
      //console.log("passport_no-----> "+comp.$root.formData.account_holder_passport_number);
      bodyFormData.append("passport_issue_date", comp.$root.formData.account_holder_passport_issue_date);
      //console.log("passport_issue_date-----> "+comp.$root.formData.account_holder_passport_issue_date);
      bodyFormData.append("passport_expiry_date", comp.$root.formData.account_holder_passport_expiry_date);
      //console.log("passport_expiry_date-----> "+comp.$root.formData.account_holder_passport_expiry_date);
      bodyFormData.append("tax_payer", comp.$root.formData.tax_payer);
      bodyFormData.append("tax_file_number", comp.$root.formData.tax_file_number);

      bodyFormData.append("ownership_of_account", comp.$root.formData.opendAccountType);
      bodyFormData.append("guardian_us_contact_no", comp.$root.formData.guardian_us_tel_number);

      //purpose page
      // bodyFormData.append("purpose_of_opening_usage", comp.$root.formData.purpose_of_opening);
      bodyFormData.append("purpose_of_opening_usage_specify", comp.$root.formData.other_purpose_of_opening);

      bodyFormData.append("source_of_funds", comp.$root.formData.source_of_fund);
      //console.log("source of funds-----> "+ comp.$root.formData.source_of_fund)

      bodyFormData.append("source_of_funds_specify", comp.$root.formData.other_source_of_fund);
      //console.log("source_of_funds_specify-----> "+ comp.$root.formData.other_source_of_fund)

      bodyFormData.append("expected_turnover", comp.$root.formData.expected_turnover.value);
      bodyFormData.append("expected_mode_of_transaction", comp.$root.formData.expected_mode_of_transaction);
      bodyFormData.append("expected_mode_of_transaction_specify", comp.$root.formData.other_expected_mode_of_transaction);
      // bodyFormData.append("")
      bodyFormData.append("asset_residential_property", comp.$root.formData.asset_residential_property);
      bodyFormData.append("asset_financial", comp.$root.formData.asset_financial);
      bodyFormData.append("asset_motor_vehicles", comp.$root.formData.asset_motor_vehicles);
      bodyFormData.append("asset_land_buildings", comp.$root.formData.asset_land_buildings);
      bodyFormData.append("asset_investments_shares", comp.$root.formData.asset_investments_shares);
      bodyFormData.append("asset_other", comp.$root.formData.asset_other);

      bodyFormData.append("asset_specify", comp.$root.formData.other_assets_held);

      bodyFormData.append("asset_residential_property_value", comp.$root.formData.asset_residential_property_value);
      bodyFormData.append("asset_investments_shares_value", comp.$root.formData.asset_investments_shares_value);
      bodyFormData.append("asset_land_buildings_value", comp.$root.formData.asset_land_buildings_value);
      bodyFormData.append("asset_motor_vehicles_value", comp.$root.formData.asset_motor_vehicles_value);
      bodyFormData.append("asset_financial_value", comp.$root.formData.asset_financial_value);
      bodyFormData.append("asset_other_value", comp.$root.formData.asset_other_value);

      bodyFormData.append('guardian_tittle', comp.$root.formData.guardian_title);
      bodyFormData.append('guardian_surname', comp.$root.formData.guardian_surname);
      bodyFormData.append('guardian_other_name', comp.$root.formData.guardian_other_name);
      bodyFormData.append('guardian_gender', comp.$root.formData.guardian_gender);
      bodyFormData.append('guardian_marital_status', comp.$root.formData.guardian_marital_status);
      bodyFormData.append('guardian_spouse_name', comp.$root.formData.guardian_spouse_name);
      bodyFormData.append('guardian_details_are_different', comp.$root.formData.guardian_details_are_different);
      bodyFormData.append('guardian_nationality_citizenship', comp.$root.formData.guardian_nationality_citizenship);
      bodyFormData.append('guardian_countryCode', comp.$root.formData.guardian_countryCode);
      bodyFormData.append('guardian_country_short_name', comp.$root.formData.guardian_country_short_name);
      bodyFormData.append('guardian_mobileNumber', comp.$root.formData.guardian_mobileNumber);
      bodyFormData.append('guardian_contact_no', comp.$root.formData.guardian_contact_no);
      bodyFormData.append('guardian_email', comp.$root.formData.guardian_email);
      bodyFormData.append('guardian_nic', comp.$root.formData.guardian_nic);
      bodyFormData.append('guardian_driving_licence', comp.$root.formData.guardian_driving_licence);
      bodyFormData.append('account_holder_driving_licence', comp.$root.formData.account_holder_driving_licence);
      bodyFormData.append('guardian_passport', comp.$root.formData.guardian_passport);
      bodyFormData.append('guardian_passport_issue_date', comp.$root.formData.guardian_passport_issue_date);
      bodyFormData.append('guardian_passport_expiry_date', comp.$root.formData.guardian_passport_expiry_date);
      bodyFormData.append('guardian_house_name', comp.$root.formData.guardian_house_name);
      bodyFormData.append('guardian_street_name', comp.$root.formData.guardian_street_name);
      bodyFormData.append('guardian_city', comp.$root.formData.guardian_city);
      bodyFormData.append('guardian_postal_code', comp.$root.formData.guardian_postal_code);
      bodyFormData.append('guardian_country', comp.$root.formData.guardian_country);
      bodyFormData.append('guardian_mailing_address_different', comp.$root.formData.guardian_mailing_address_different);
      bodyFormData.append('guardian_mailing_house_name', comp.$root.formData.guardian_mailing_house_name);
      bodyFormData.append('guardian_mailing_street_name', comp.$root.formData.guardian_mailing_street_name);
      bodyFormData.append('guardian_mailing_city', comp.$root.formData.guardian_mailing_city);
      bodyFormData.append('guardian_mailing_postal_code', comp.$root.formData.guardian_mailing_postal_code);
      bodyFormData.append('guardian_mailing_country', comp.$root.formData.guardian_mailing_country);
      bodyFormData.append('guardian_us_person', comp.$root.formData.guardian_us_person);
      bodyFormData.append('guardian_acc_num', comp.$root.formData.guardian_acc_num);
      bodyFormData.append('guardian_place_of_birth', comp.$root.formData.guardian_place_of_birth);
      bodyFormData.append('guardian_us_permanent_address_different', comp.$root.formData.guardian_us_permanent_address_different);
      bodyFormData.append('guardian_us_house_name', comp.$root.formData.guardian_us_house_name);
      bodyFormData.append('guardian_us_street_name', comp.$root.formData.guardian_us_street_name);
      bodyFormData.append('guardian_us_city', comp.$root.formData.guardian_us_city);
      bodyFormData.append('guardian_us_postal_code', comp.$root.formData.guardian_us_postal_code);
      bodyFormData.append('guardian_us_country', comp.$root.formData.guardian_us_country);
      bodyFormData.append('guardian_us_mailing_address_different', comp.$root.formData.guardian_us_mailing_address_different);
      bodyFormData.append('guardian_us_mailing_house_name', comp.$root.formData.guardian_us_mailing_house_name);
      bodyFormData.append('guardian_us_mailing_street_name', comp.$root.formData.guardian_us_mailing_street_name);
      bodyFormData.append('guardian_us_mailing_city', comp.$root.formData.guardian_us_mailing_city);
      bodyFormData.append('guardian_us_mailing_postal_code', comp.$root.formData.guardian_us_mailing_postal_code);
      bodyFormData.append('guardian_us_mailing_country', comp.$root.formData.guardian_us_mailing_country);
      bodyFormData.append('guardian_us_passport', comp.$root.formData.guardian_us_passport);
      bodyFormData.append('guardian_tax_idetification_number', comp.$root.formData.guardian_tax_idetification_number);
      bodyFormData.append('guardian_are_you_a_tax_payer', comp.$root.formData.guardian_are_you_a_tax_payer);
      bodyFormData.append('guardian_tax_file_number', comp.$root.formData.guardian_tax_file_number);
      bodyFormData.append('guardian_political_exposed', comp.$root.formData.guardian_political_exposed);
      bodyFormData.append('guardian_political_exposed_position', comp.$root.formData.guardian_political_exposed_position);
      bodyFormData.append('guardian_closer_relatives_politically_exposed', comp.$root.formData.guardian_closer_relatives_politically_exposed);
      bodyFormData.append('relationship_to_the_acc_holder', comp.$root.formData.relationship_to_the_acc_holder);
      bodyFormData.append('account_holder_dob', comp.$root.formData.account_holder_dob);
      bodyFormData.append('guardian_resident_country', comp.$root.formData.guardian_resident_country);
      bodyFormData.append('guardian_citizenship_country', comp.$root.formData.guardian_citizenship_country);
      bodyFormData.append('guardian_residency', comp.$root.formData.guardian_residency);
      bodyFormData.append('childrenAccountOpeningPurpose', comp.$root.formData.childrenAccountOpeningPurpose);

      bodyFormData.append('donor_residentship', comp.$root.formData.donorResidentship);
      bodyFormData.append('donor_resident_country', comp.$root.formData.donorResidentCountry);









      //vas page
      // bodyFormData.append("vas_sms_alerts", comp.$root.formData.sms_service);
      // bodyFormData.append("vas_internet_banking", comp.$root.formData.e_banking_service);
      // bodyFormData.append("vas_virtual_wallet", comp.$root.formData.virtual_wallet_service);
      // bodyFormData.append("vas_estatement", comp.$root.formData.estatement_service);
      // bodyFormData.append("vas_debit_card", comp.$root.formData.debit_card_service);
      // bodyFormData.append("vas_pos_required", comp.$root.formData.pos_required);
      // bodyFormData.append("vas_acc_linked_pos_transaction", comp.$root.formData.account_to_be_linked);
      // bodyFormData.append("vas_card_delivery_details", comp.$root.formData.card_delivery);
      // bodyFormData.append("vas_pin_delivery_details", comp.$root.formData.card_pin_delivery);
      // bodyFormData.append("vas_card_type", comp.$root.formData.facility_debit_card_type);
      // bodyFormData.append("mother_maiden_name", comp.$root.formData.mother_maiden_name);

      //document page
      bodyFormData.append("birth_certificate_front_image", comp.$root.productImages.birth_certificate_front_image);
      bodyFormData.append("birth_certificate_back_image", comp.$root.productImages.birth_certificate_back_image);
      bodyFormData.append("passport_bio_page_image", comp.$root.productImages.passport_bio_page_image);
      bodyFormData.append("passport_alterations_page_image", comp.$root.productImages.passport_alteration_page_image);
      bodyFormData.append("passport_entry_stamp_page_image", comp.$root.productImages.passport_entry_stamp_page_image);
      bodyFormData.append("guardian_passport_bio_page_image", comp.$root.productImages.guardian_passport_bio_page_image);
      bodyFormData.append("guardian_passport_alterations_page_image", comp.$root.productImages.guardian_passport_alteration_page_image);
      bodyFormData.append("guardian_passport_entry_stamp_page_image", comp.$root.productImages.guardian_passport_entry_stamp_page_image);
      bodyFormData.append("driving_licence_image", comp.$root.productImages.driving_licence_image);

      //us person perment and mailing address
      bodyFormData.append("us_person_permanent_address_line1", comp.$root.formData.us_person_permanent_address_line1);
      bodyFormData.append("us_person_permanent_address_line2", comp.$root.formData.us_person_permanent_address_line2);
      bodyFormData.append("us_person_permanent_address_line3", comp.$root.formData.us_person_permanent_address_line3);
      bodyFormData.append("us_person_permanent_address_postal_code", comp.$root.formData.us_person_permanent_address_postal_code);
      bodyFormData.append("us_person_permanent_address_country", comp.$root.formData.us_person_permanent_address_country);
      bodyFormData.append("us_person_mailing_address_line1", comp.$root.formData.us_person_mailing_address_line1);
      bodyFormData.append("us_person_mailing_address_line2", comp.$root.formData.us_person_mailing_address_line2);
      bodyFormData.append("us_person_mailing_address_line3", comp.$root.formData.us_person_mailing_address_line3);
      bodyFormData.append("us_person_mailing_address_postal_code", comp.$root.formData.us_person_mailing_address_postal_code);
      bodyFormData.append("us_person_mailing_address_country", comp.$root.formData.us_person_mailing_address_country);

      bodyFormData.append("donor_permanent_address_line1", comp.$root.formData.donor_permanent_address_line1);
      bodyFormData.append("donor_permanent_address_line2", comp.$root.formData.donor_permanent_address_line2);
      bodyFormData.append("donor_permanent_address_line3", comp.$root.formData.donor_permanent_address_line3);
      bodyFormData.append("donor_permanent_address_postal_code", comp.$root.formData.donor_permanent_address_postal_code);
      bodyFormData.append("donor_permanent_address_country", comp.$root.formData.donor_permanent_address_country);
      bodyFormData.append("donor_mailing_address_line1", comp.$root.formData.donor_mailing_address_line1);
      bodyFormData.append("donor_mailing_address_line2", comp.$root.formData.donor_mailing_address_line2);
      bodyFormData.append("donor_mailing_address_line3", comp.$root.formData.donor_mailing_address_line3);
      bodyFormData.append("donor_mailing_address_postal_code", comp.$root.formData.donor_mailing_address_postal_code);
      bodyFormData.append("donor_mailing_address_country", comp.$root.formData.donor_mailing_address_country);
      bodyFormData.append("donor_mailing_address_same_as_permanent_address", comp.$root.formData.donor_mailing_address_same_as_permanent_address);

      bodyFormData.append("doners_name", comp.$root.formData.donorsName);

      bodyFormData.append("account_holders_name", comp.$root.formData.otherBankAccountHolderName);

      bodyFormData.append("guardian_dob", comp.$root.formData.guardianDob)



      // bodyFormData.append("")
      // bodyFormData.append("", comp.$root.formData.us_person);

      bodyFormData.append("us_person", comp.$root.formData.us_person);
      bodyFormData.append("mailing_address_in_us_same_as_permanent_address", comp.$root.formData.mailing_address_in_us_same_as_permanent_address_in_us);

      
      bodyFormData.append(
        "us_person_account_numbers",
        comp.$root.formData.us_person_account_numbers
      );
      bodyFormData.append(
        "us_person_place_of_birth",
        comp.$root.formData.us_person_place_of_birth
      );
      bodyFormData.append(
        "us_person_permanent_address",
        comp.$root.formData.us_person_permanent_address
      );
      bodyFormData.append(
        "us_person_correspondent_address",
        comp.$root.formData.us_person_correspondent_address
      );
      bodyFormData.append(
        "us_person_passport_no",
        comp.$root.formData.us_person_passport_no
      );
      bodyFormData.append(
        "us_person_telephone_no",
        comp.$root.formData.us_person_telephone_no
      );

      if (
        comp.$root.formData.citizenship === "Sri Lankan with Dual Citizenship"
      ) {
        bodyFormData.append(
          "dual_citizen_countries",
          comp.$root.formData.dual_citizen_countries
        );
      } else if (
        comp.$root.formData.citizenship ===
        "Foreign National with Dual Citizenship"
      ) {
        bodyFormData.append(
          "dual_citizen_countries",
          comp.$root.formData.dual_citizen_countries.toString()
        );
      }

      bodyFormData.append(
        "us_person_tax_identification_no",
        comp.$root.formData.us_person_tax_identification_no
      );
      bodyFormData.append(
        "facility_internet_banking",
        comp.$root.formData.facility_internet_banking
      );
      bodyFormData.append(
        "facility_debit_card",
        comp.$root.formData.facility_debit_card
      );
      bodyFormData.append(
        "facility_debit_card_type",
        comp.$root.formData.facility_debit_card_type
      );
      bodyFormData.append(
        "vas_visa_card_name",
        comp.$root.formData.facility_debit_card_customer_name
      );

      bodyFormData.append(
        "foreign_national_country",
        comp.$root.formData.foreign_national_country
      );
      bodyFormData.append(
        "resident_countries",
        JSON.stringify(comp.$root.formData.resident_countries)
      );
      bodyFormData.append(
        "visa_proof_doc",
        comp.$root.productImages.visa_proof_doc
      );

      
     

      // bodyFormData.append("indemnity", indemnity);
      bodyFormData.append(
        "locationAccess",
        comp.$root.formData.nicNumberAllowToLocationServicesInYourBrowser
      );
      bodyFormData.append(
        "nicVerificationDRP",
        comp.$root.formData.nicNumberAllowToDRP
      );

      // bodyFormData.append('keystroke_dynamics', JSON.stringify(comp.$root.keyStrokeDynamics));
      bodyFormData.append(
        "keystroke_dynamics",
        JSON.stringify(comp.$root.keyStrokeDynamics)
      ); // this was added - used in other branches
      // bodyFormData.append("keystroke_dynamics",JSON.stringify(comp.$root.keyStrokeStatics)); // this was added

      bodyFormData.append(
        "face_ids",
        JSON.stringify(comp.$root.formData.face_ids)
      ); //added

      bodyFormData.append(
        "location_details",
        JSON.stringify(comp.$root.formData.location_details)
      );

      var language = "en";
      if (comp.$root.selectedLanguage == "en") {
        language = "english";
      } else if (comp.$root.selectedLanguage == "ta") {
        language = "tamil";
      } else {
        language = "sinhala";
      }

      bodyFormData.append("preferred_language", language);
      bodyFormData.append("introduced_by", comp.$root.formData.introduced_by);

      bodyFormData.append(
        "nic_front_image",
        comp.$root.productImages.nic_front_image
      );
      bodyFormData.append(
        "nic_back_image",
        comp.$root.productImages.nic_back_image
      );
      bodyFormData.append(
        "selfie_image",
        comp.$root.productImages.selfie_image
      );
      bodyFormData.append("sign_image", comp.$root.productImages.sign_image);
      bodyFormData.append(
        "addr_proof_doc",
        comp.$root.productImages.addr_proof_doc
      );

      

      // new modification - 2022-9-22 - new field adding ---------------------------------------------------------------
      bodyFormData.append(
        "passport_image",
        comp.$root.productImages.passport_image
      );
      bodyFormData.append(
        "customer_passport_no",
        comp.$root.formData.account_holder_passport_number.toUpperCase()
      );

      bodyFormData.append("customer_preferred_time", comp.$root.formData.videoCallTimeSlot);
      bodyFormData.append("customer_preferred_date", comp.$root.formData.videoCallDate);


      // permanent address
      bodyFormData.append(
        "permanent_address_line1",
        comp.$root.formData.permanent_address_line1
      );
      bodyFormData.append(
        "permanent_address_line2",
        comp.$root.formData.permanent_address_line2
      );
      bodyFormData.append(
        "permanent_address_line3",
        comp.$root.formData.permanent_address_line3
      );
      bodyFormData.append(
        "permanent_address_postal_code",
        comp.$root.formData.permanent_address_postal_code
      );
      bodyFormData.append(
        "permanent_address_country",
        comp.$root.formData.permanent_address_country
      );

      bodyFormData.append(
        "mailing_address_same_as_permanent_address",
        comp.$root.formData.mailing_address_same_as_permanent_address
      );

      // mailing address
      bodyFormData.append(
        "mailing_address_line1",
        comp.$root.formData.mailing_address_line1
      );
      bodyFormData.append(
        "mailing_address_line2",
        comp.$root.formData.mailing_address_line2
      );
      bodyFormData.append(
        "mailing_address_line3",
        comp.$root.formData.mailing_address_line3
      );
      bodyFormData.append(
        "mailing_address_postal_code",
        comp.$root.formData.mailing_address_postal_code
      );
      bodyFormData.append(
        "mailing_address_country",
        comp.$root.formData.mailing_address_country
      );

      // foreign address
      bodyFormData.append(
        "foreign_address_line1",
        comp.$root.formData.foreign_address_line1
      );
      bodyFormData.append(
        "foreign_address_line2",
        comp.$root.formData.foreign_address_line2
      );
      bodyFormData.append(
        "foreign_address_line3",
        comp.$root.formData.foreign_address_line3
      );
      bodyFormData.append(
        "foreign_address_postal_code",
        comp.$root.formData.foreign_address_postal_code
      );
      bodyFormData.append(
        "foreign_address_country",
        comp.$root.formData.foreign_address_country
      );

      // us-person correspondent address
      bodyFormData.append(
        "correspondent_address_line1",
        comp.$root.formData.correspondent_address_line1
      );
      bodyFormData.append(
        "correspondent_address_line2",
        comp.$root.formData.correspondent_address_line2
      );
      bodyFormData.append(
        "correspondent_address_line3",
        comp.$root.formData.correspondent_address_line3
      );
      bodyFormData.append(
        "correspondent_address_postal_code",
        comp.$root.formData.correspondent_address_postal_code
      );
      bodyFormData.append(
        "correspondent_address_country",
        comp.$root.formData.correspondent_address_country
      );

      bodyFormData.append("surname", comp.$root.formData.surname);
      bodyFormData.append("other_name", comp.$root.formData.other_name);
      let kyc_token = comp.$root.formData.kyc_token +'.'+ comp.$root.formData.color_code4 +'.'+ comp.$root.formData.color_code12

      comp.$http
        .post(comp.$baseURL + "/kycForm/submitKycForm", bodyFormData, {
          headers: { "Content-Type": "multipart/form-data","X-token":kyc_token },
        })
        .then(function (response) {
          //handle success

          console.log("successfully submitted--------------");
          console.log(response);

          comp.isContinueButtonLoading = false;
          comp.$root.isFormSubmitted = true;

          comp.$router.push("congratulation");
        })
        .catch(function (response) {
          //handle error
          console.log(response);
          comp.$buefy.toast.open({
            message: "Failed to submit form data",
            type: "is-danger",
          });
        });
    },


    guardianFlowContinuer(){
      const queryString = window.location.search;
      let formID = queryString.replace(/^\D+/g, '')
      console.log(">>>>>>",formID);
      this.$http.post(
          this.$baseURL + "/updateTokenGiftedAccount",
          {'id' : formID},
      )
          .then((response) => {
            this.isLoading = false;
            if (response.data.success) {
              console.log(response.data)
              this.isContinueFromDonor = response.data.data.is_doner_filled
              this.$root.isPreviouslyDonorFilled = response.data.data.is_doner_filled
              this.$root.formData.color_code1 = response.data.data.color_code1;
              this.$root.formData.color_code2 = response.data.data.color_code2;
              this.$root.formData.color_code3 = response.data.data.color_code3;
              this.$root.formData.color_code4 = response.data.data.color_code4;
              this.$root.formData.color_code5 = response.data.data.color_code5;
              this.$root.formData.color_code6 = response.data.data.color_code6;
              this.$root.formData.color_code7 = response.data.data.color_code7;
              this.$root.formData.color_code8 = response.data.data.color_code8;
              this.$root.formData.color_code9 = response.data.data.color_code9;
              this.$root.formData.color_code10 = response.data.data.color_code10;
              this.$root.formData.color_code11 = response.data.data.color_code11;
              this.$root.formData.color_code12 = response.data.data.color_code12;
              this.$root.formData.color_code13 = response.data.data.color_code13;
              this.$root.formData.color_code14 = response.data.data.color_code14;
              this.$root.formData.color_code15 = response.data.data.color_code15;
              this.$root.formData.color_code16 = response.data.data.color_code16;
              this.$root.formData.kyc_token = response.data.data.token;
              this.$root.formData.guardian_email = response.data.data.guardian_email;
            }
          })
          .catch((response) => {
            this.$buefy.toast.open({
              message: response.message,
              type: "is-danger",
            });
          });

    },

    validateMobileNumber() {
      if (this.newCountryCode === "+94") {
        console.log("LK Mobile number ---------------");
        const tempMobileNumber = this.yourMobileNumber.trim();
        if (tempMobileNumber[0] === "0") {
          this.isMobileNumberStartsWithZero = true;
        } else {
          this.isMobileNumberStartsWithZero = false;
        }
      } else {
        this.isMobileNumberStartsWithZero = false;
      }
    },
  },
  computed: {
    filteredDataArr() {
      return this.countryCodeArray.filter((option) => {
        return option.toLowerCase().indexOf(this.userCode.toLowerCase()) >= 0;
      });
    },
  },
  mounted: function () {
    // console.log("prevous path kicked")
    if (this.previousRoute.fullPath === '/preview-page' || this.previousRoute.fullPath === '/guardians_information'){

      // if form already submitted, avoid to get verification screen-----------
      if (this.$root.isFormSubmitted) {
        this.$router.push("congratulation");
      } else {
        this.$root.formData.Otp = "";
        this.emailButtonAction();
      }
      for (const country of this.$root.formData.countriesList) {
        this.countryCodeArray.push(`${country.code} ${country.phone}`);
      }
      if (!this.$root.formData.countryCode) {
        this.$root.formData.countryCode = "+94";
      }
      const tempCountryCodeName = this.$root.formData.countriesList.find(
          (country) => country.phone === this.$root.formData.countryCode
      );
      this.userCode = this.countryCodeArray.find(
          (hello) =>
              hello ===
              `${tempCountryCodeName.code} ${this.$root.formData.countryCode}`
      );

      this.yourMobileNumber = this.$root.formData.mobileNumber;
      this.newCountryCode = this.$root.formData.countryCode;
      this.changeSelection();
      this.updateLastStep();
    }
    else {
      this.guardianFlowContinuer();
    }

  },
};
</script>
<style lang="scss" scoped>
.calMobileError {
  display: none;
}
.px-3 {
  width: 50%;
  margin:auto;
}

@media (max-width: 500px) {
  /* Adjust the margin-top for the mobile view */
  .px-3 {
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
    width: 85%;
  }
  .verificationText{
    font-size: 2.5rem !important;
  }

}

</style>
